import React, { memo } from 'react';
import cn from 'classnames';
import IconCheckBox from '../../../../../../components/icon-checkbox';
import styles from './FlagControl.module.scss';

const FlagControl = ({ active, icon, onChange, children }) => (
  <button
    type="button"
    className={cn(styles.root, {
      [styles.active]: active,
    })}
    aria-pressed={Boolean(active)}
    onClick={() => {
      if (typeof onChange === 'function') {
        onChange(!active);
      }
    }}
  >
    <IconCheckBox
      icon={icon}
      value={active}
    >
      {children}
    </IconCheckBox>
  </button>
);

export default memo(FlagControl);
